import { render } from "./BatchSign.vue?vue&type=template&id=3835676b&scoped=true&ts=true"
import script from "./BatchSign.vue?vue&type=script&lang=ts"
export * from "./BatchSign.vue?vue&type=script&lang=ts"

import "./BatchSign.vue?vue&type=style&index=0&id=3835676b&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3835676b"]])

export default __exports__